export interface TourPlayerState {
    distance: number;
    isPlaying: boolean;
}

export const createDefaultPlayerState = (): TourPlayerState => ({ distance: 0, isPlaying: false });